export const data = {
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Welcome",
    Main_Nav_HelpfulLinks: "Helpful Links",
    Main_Nav_LogOut: "LOGOUT",
    Main_Nav_HelpfulLinks_LI_s1: "Contact My Student(s) Nurse",
    Main_Nav_HelpfulLinks_LI_s2: "Academic Calendars",
    Main_Nav_HelpfulLinks_LI_s3: "Parent Resources",
    Main_Nav_HelpfulLinks_LI_s4: "Bus Routes",
    Main_Nav_HelpfulLinks_LI_s5: "Online Payments",
    Main_Nav_HelpfulLinks_LI_s6: "Lunch Menus",
    Main_Nav_Exit: "EXIT",
    Main_Nav_Tagline: "Learn Today. Lead Tomorrow.",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "Add",
    Global_Close: "Close",
    Global_Completed: "Completed",
    Global_InProgress: "In Progress",
    Global_GoTo: "Go To",
    Global_MoreInfo: "More Info",
    Global_NotStarted: "Not Started",
    Global_Open: "Open",
    Global_OpenFrom: "Open From", // <some date> - <some date>
    Global_Status: "Status",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Welcome to DCSD Financial Transparency",
    Breadcrumb_Translations: "Translations are experimental",
    /// /////////////////////////////////////////////////////////
    /// //////////////// Main ///////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Instruction: (
        <ul>
            <li>
                This tool allows the public to search and export financial expenditure information for DCSD as of July
                1st, 2017.
            </li>
            <li>
                View a{" "}
                <a
                    href="https://www.dcsdk12.org/about/departments/business-services/budget-and-accounting"
                    rel="noreferrer"
                    target="_blank"
                >
                    Chart of Accounts
                </a>{" "}
                applicable to DCSD transactions under &ldquo;Resources&rdquo; section.
            </li>
            <li>
                Please consider the context when evaluating financial transactions. We welcome your questions regarding
                our financial transactions or records.
            </li>
        </ul>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////// Faceted Search //////////////////////////
    /// /////////////////////////////////////////////////////////
    Facet_Keyword: "Enter Keyword Here",
    Facet_Export: "Export CSV",
    Facet_Search: "Search",
    /// /////////////////////////////////////////////////////////
    /// ///////////////// Forms /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Fiscal_Year: "Fiscal Year",
    Fiscal_Year_Instruction: (
        <h5>
            Which <b>Fiscal Year</b> would you like to view?
        </h5>
    ),
    Quarter_Instruction: (
        <>
            <h5>
                Which <b>Quarter</b> would you like to view?
            </h5>
            <p>
                Select one of the available fiscal year quarters to generate an initial results set. Future quarters
                cannot be selected.
            </p>
        </>
    ),
    Quarter_View: "View",
    /// /////////////////////////////////////////////////////////
    /// ///////////////// Results ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    Results_Title: "Search Results",
    Results_Instruction:
        'Search results are listed below. Search results can be further refined by Fund, Location, Payment Type, and Spend Category. Users may also use the Keyword search to help find specific expenditure information within filtered results. Search results can be exported (.csv format) by clicking the "Export CSV" button.',
    Results_No_Results: "No Payments Found"
};
